import { z } from 'zod';
import { isValidUrl } from '@shared/utils/url';
import * as O from 'fp-ts/Option';

export const emailZodSchema = z.string().regex(
  // eslint-disable-next-line no-control-regex
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
  { message: "Le format d'email est incorrect" },
);

export const urlSchema = z.string().refine(value => isValidUrl(value), { message: "L'url est invalide" });

export const ipAddressSchema = z
  .string()
  .regex(
    /^(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])$/,
  );
export const maximalMembersSchema = z.coerce
  .number()
  .nullable()
  .transform(value => (value === 0 ? null : value));
export const NonEmptyString = z.string().min(1);
export type NonEmptyString = z.infer<typeof NonEmptyString>;

export namespace Zod {
  export namespace NonEmptyArray {
    export function fromArray<T>(list: Array<T>): O.Option<[T, ...T[]]> {
      const parsed = z.array(z.any()).nonempty().safeParse(list);
      return parsed.success ? O.some(parsed.data) : O.none;
    }
  }
}
